module.exports = __webpack_public_path__ + "img/PS28.38905852.png";